import { CustomTable, UserAvatarWithName } from 'components'
import { GetUserFollowingCreatorsList } from 'hooks'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

export const ViewersTable = () => {
  const { id } = useParams()
  const { data, filter, pageChanged, total, loading } = GetUserFollowingCreatorsList(id)
  const columns = useMemo(
    () => [
      {
        title: 'Creator Name',
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
          <UserAvatarWithName id={record?.fid} title={record.name} url={record.photo_url} />
        ),
      },

      // {
      //   title: 'Genre',
      //   dataIndex: 'genre',
      //   key: 'genre',
      // },
      // {
      //   title: 'Followers',
      //   dataIndex: 'followers',
      //   key: 'followers',
      //   render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      // },
      // {
      //   title: ' Videos',
      //   dataIndex: 'videos',
      //   key: 'videos',
      //   render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      // },
    ],
    [data],
  )

  return (
    <div>
      <div className="">
        <CustomTable
          data={data}
          columns={columns}
          pageChanged={pageChanged}
          page={filter.page}
          loading={loading}
          total={total}
          pageSize={filter.limit}
        />

      </div>
    </div>
  )
}
